import {
	cancelActivationMissingOrdersSuccess,
	confirmActivationMissingOrdersSuccess,
	confirmActivationMissingStatusSuccess,
	getActivationMissingOrdersSuccess,
	selectActivationMissingItemSuccess
} from 'actions'
import {
	cancelActivationMissingOrdersApi,
	confirmActivationMissingOrdersApi,
	confirmActivationMissingStatusApi,
	getActivationMissingOrdersApi,
	selectActivationMissingItemApi
} from 'api/ActivationMissingOrders'
import { ActivationMissingActions } from 'constants/ActionsTypesTs'
import {
	ICancelMissingOrdersAction,
	ICancelMissingOrdersResponse,
	IConfirmMissingOrdersAction,
	IConfirmMissingOrdersResponse,
	IConfirmMissingOrdersStatusAction,
	IConfirmMissingOrdersStatusResponse,
	IGetActivationMissingOrdersAction,
	IGetActivationMissingOrdersResponse,
	ISelectActivationMissingItemAction,
	ISelectActivationMissingItemResponse
} from 'models/ActivationMissingOrders'
import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

function* getActivationMissingOrdersRequest({
	payload
}: IGetActivationMissingOrdersAction): any {
	try {
		const items: IGetActivationMissingOrdersResponse = yield call(
			getActivationMissingOrdersApi,
			payload
		)
		yield put(getActivationMissingOrdersSuccess(items))
	} catch (error: any) {}
}

function* selectActivationMissingItemRequest({
	payload
}: ISelectActivationMissingItemAction): any {
	try {
		const items: ISelectActivationMissingItemResponse = yield call(
			selectActivationMissingItemApi,
			payload
		)
		yield put(selectActivationMissingItemSuccess(items))
	} catch (error: any) {}
}

function* confirmActivationMissingOrdersRequest({
	payload
}: IConfirmMissingOrdersAction): any {
	try {
		const items: IConfirmMissingOrdersResponse = yield call(
			confirmActivationMissingOrdersApi,
			payload
		)
		yield put(confirmActivationMissingOrdersSuccess(items))
	} catch (error: any) {}
}

function* confirmActivationMissingStatusRequest({
	payload
}: IConfirmMissingOrdersStatusAction): any {
	try {
		const items: IConfirmMissingOrdersStatusResponse = yield call(
			confirmActivationMissingStatusApi,
			payload
		)
		yield put(confirmActivationMissingStatusSuccess(items))
	} catch (error: any) {}
}

function* cancelActivationMissingOrdersRequest({
	payload
}: ICancelMissingOrdersAction): any {
	try {
		const items: ICancelMissingOrdersResponse = yield call(
			cancelActivationMissingOrdersApi,
			payload
		)
		yield put(cancelActivationMissingOrdersSuccess(items))
	} catch (error: any) {}
}

export function* getActivationMissingOrdersSaga() {
	yield takeEvery(
		ActivationMissingActions.GET_ACTIVATION_MISSING_ORDERS,
		getActivationMissingOrdersRequest
	)
}

export function* selectActivationMissingItemSaga() {
	yield takeEvery(
		ActivationMissingActions.SELECT_ACTIVATION_MISSING_ITEM,
		selectActivationMissingItemRequest
	)
}

export function* confirmActivationMissingOrdersSaga() {
	yield takeEvery(
		ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_ITEMS,
		confirmActivationMissingOrdersRequest
	)
}

export function* confirmActivationMissingStatusSaga() {
	yield takeEvery(
		ActivationMissingActions.CONFIRM_ACTIVATION_MISSING_STATUS,
		confirmActivationMissingStatusRequest
	)
}

export function* cancelActivationMissingOrdersSaga() {
	yield takeEvery(
		ActivationMissingActions.CANCEL_ACTIVATION_MISSING,
		cancelActivationMissingOrdersRequest
	)
}

export default function* rootSaga() {
	yield all([
		fork(getActivationMissingOrdersSaga),
		fork(selectActivationMissingItemSaga),
		fork(confirmActivationMissingOrdersSaga),
		fork(confirmActivationMissingStatusSaga),
		fork(cancelActivationMissingOrdersSaga)
	])
}
